(function () {
    'use strict';

    angular
        .module('app')
        .controller('NotificationCtrl', ['$uibModal', 'appData', NotificationCtrl]);

    function NotificationCtrl($uibModal, appData) {
        var vm = this;

        vm.notification = appData.notification;
        vm.viewNotification = viewNotification;

        ////////////////////////////////////////////

        function viewNotification() {
            $uibModal.open({
                templateUrl: 'shared/notification.html',
                controller: ['$scope', function($scope) {
                    $scope.description = appData.notification.description;
                }]
            });
        }

    };

})();